<template>
  <div id="app">
		<top-bar/>
		<div id="main-wrap">
			<router-view></router-view>
		</div>
  </div>
</template>

<script>
export default {
	name: 'App'
};
</script>

<style lang="scss">
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import "./scss/index.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue